import { PostTypeAsPostCardPrefix } from '../../constants';

/**
 * Парсит урл карточки поста
 */
export const parsePostCardPath = (path: string) => {
  const matches = path.match(
    new RegExp(`^/(${Object.values(PostTypeAsPostCardPrefix).join('|')})-(?:([^/]+)-)?([0-9]+)/?$`),
  );

  return { prefix: matches?.[1], slug: matches?.[2], id: parseInt(matches?.[3] || '0', 10) };
};
